import React from "react";

// Context
import {
  ACTIONS,
  useModalHistory,
} from "../../../context/ModalHistoryProvider";

// Components
import { ExcelUploadButton } from "../../Controls/ExcelUploadButton";
import { IndividualDealButton } from "../../Controls/IndividualDealButton";
import StackStyle from "../../Styled/Stack.style";
import ExcelDealsUploadModal from "../UploadDeal/ExcelDealsUploadModal";
import IndividualDealCreateModal from "../IndividualDealCreate/IndividualDealCreateModal";
import Modal from "../../Modal/Modal";
import { NEW_CARS_ALLOWED_USERS, USER_KEY } from "../../../utils/constants/SYSTEM";
import { get } from "../../../utils/helpers/storage";

export default function AddNewDealsModal() {
  const [, dispatchModalHistory] = useModalHistory();
  const user = get(USER_KEY);
  const isNewCarsAllowedUser = NEW_CARS_ALLOWED_USERS.includes(user?.emailAddress?.toLowerCase());

  const pushEnd = (modal) =>
    dispatchModalHistory({ type: ACTIONS.PUSH_END, payload: { value: modal } });

  return (
    <Modal title="Add new deals">
      <StackStyle gap="20px">
        <ExcelUploadButton onClick={() => pushEnd(<ExcelDealsUploadModal />)} disabled={!isNewCarsAllowedUser} />
        <IndividualDealButton
          onClick={() => pushEnd(<IndividualDealCreateModal />)}
        />
      </StackStyle>
    </Modal>
  );
}
